import { useGetAdminIsAuthenticated } from '@sit/client-shared';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import Spinner from '../../components/Spinner';

const getInitialUrl = () => {
  const sessionItem = sessionStorage.getItem('saml_initial_url');
  return sessionItem || null;
};

const SamlCallback = () => {
  const navigate = useNavigate();

  useGetAdminIsAuthenticated();

  useEffect(() => {
    const initialUrl = getInitialUrl();
    if (initialUrl?.includes('saml')) {
      navigate('/');
    } else {
      navigate(initialUrl || '/');
    }
  }, [navigate]);

  return <Spinner />;
};

export default SamlCallback;
